import { AxiosPromise } from 'axios';
import request from '@/utils/request';
import type { MemberInfoVo } from './types.ts';
/**
 * 获取脱敏信息
 */
export const sensitiveVal = () => {
  return request({
    url: '/member/user/getInfo',
    method: 'get'
  });
};
/**
 * 登录后获取会员信息 会员状态
 */
export const memberInfo = (): AxiosPromise<MemberInfoVo> => {
  return request({
    url: '/member/user/memberInfo',
    method: 'get'
  });
};

/**
 * 有偿任务 news count
 */
export const newsCount = (): AxiosPromise<MemberInfoVo> => {
  return request({
    url: '/affiliate/paid/task/newsCount',
    method: 'get'
  });
};
